import React from 'react';

import { ReactComponent as ScanIcon } from 'assets/scan.svg';

import QrCodeModal from './QrCodeModal/QrCodeModal';

import styles from './QrCodeCTA.module.scss';

const QrCodeCTA: React.FC<{ trackingId: string }> = ({ trackingId }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <button className={styles.qrCodeButton} onClick={() => setIsModalOpen(true)}>
        <ScanIcon aria-hidden />
        View collection QR code
      </button>
      <QrCodeModal trackingId={trackingId} isOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default QrCodeCTA;
